export const configConstants = {
    TOKEN_NAME: 'token',
    PARTNER_TOKEN: 'partner_token'
};
